module.exports = __webpack_public_path__ + "static/media/home-bpo.c927cc75.jpg";